var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .circleComponent {\n            animation: App-logo-spin 1s ease 1 normal forwards;\n            /* For a spiral change this to 0.1s and add the delays below */\n          }\n\n          @keyframes App-logo-spin {\n            0% {\n                  stroke-dasharray: 0 188.49555921538757\n              }\n            100% {\n                stroke-dasharray: 15.707963267948964 188.49555921538757\n            }\n          }\n        ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(252, 254, 7)",
    transform: "rotate(-90.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(252, 143, 9)",
    transform: "rotate(-60.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(252, 91, 9)",
    transform: "rotate(-30.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(252, 44, 8)",
    transform: "rotate(0.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(198, 6, 9)",
    transform: "rotate(30.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(145, 6, 89)",
    transform: "rotate(60.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(89, 6, 90)",
    transform: "rotate(90.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(8, 6, 88)",
    transform: "rotate(120.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(13, 50, 144)",
    transform: "rotate(150.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(8, 91, 90)",
    transform: "rotate(180.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(47, 141, 11)",
    transform: "rotate(210.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circleComponent",
    r: 30,
    cx: 50,
    cy: 50,
    stroke: "rgb(88, 200, 0)",
    transform: "rotate(240.0 50 50)",
    strokeDasharray: "0 188.49555921538757",
    strokeWidth: 12,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2bde22a63ed918518b6e45399ca9210.svg";
export { ForwardRef as ReactComponent };